import Component from 'vue-class-component';
import { Vue, Prop, Watch } from 'vue-property-decorator';

@Component({
  inheritAttrs: false,
})
export default class IPSDatePicker extends Vue {
  @Prop()
    firstValue;

  @Prop()
    secondValue;

  // @ts-expect-error
  dateValue = [this.firstValue, this.secondValue];

  @Watch('secondValue')
  onValueChange(n, o) {
    if (n && n !== o) {
      this.dateValue = [this.firstValue, this.secondValue];
    }
  }

  dateValueChange() {
    this.$emit('update:firstValue', this.dateValue ? this.dateValue[0] : null);
    this.$emit('update:secondValue', this.dateValue ? this.dateValue[1] : null);
  }

  render(h) {
    return <el-date-picker v-model={this.dateValue} {...{ props: { ...this.$attrs, ...this.$props } }} onChange={this.dateValueChange.bind(this)} />;
  }
}
